<template>
  <div class="my">
    <div class="user van-hairline--bottom">
      <div class="user-left">
        <!-- <i class="user-left__img iconfont icon-xuesheng"></i> -->
        <div style="position:relative;">
          <img class="user-left__img" :src="studentPic" />
          <input
            :value="picUrl"
            accept="image/*"
            type="file"
            id="picInput"
            style="opacity: 0;
            width: 100%;
            height: 100%;
            z-index: 999;
            position: absolute;
            left: 0;"
            @change="handleChangePicUrl($event)"
          />
        </div>
        <p class="user-left__name">{{ studnetInfo.Studentname }}</p>
        <i class="user-left__switch iconfont icon-qiehuan1" @click="hrefStudent"></i>
      </div>
      <div class="user-right">
        <p>学校：{{ studnetInfo.Schoolname }}</p>
        <p>班级：{{ studnetInfo.Gradename }}{{ studnetInfo.Classname }}</p>
       
        <p class="call">
          电话：
          <a :href="`tel:${studnetInfo.Phone}`">
            {{ studnetInfo.Phone }}
            <img v-if="studnetInfo.Phone!=''"
              class="icon closeImg"
              style="width: 13px; height: 13px; margin-left: 10px; margin-right: 10px"
              src="../../assets/images/phone.gif"
            />
            <!-- <svg class="icon closeImg" aria-hidden="true" >
              <use xlink:href="#icon-dianhua1"></use>
            </svg> -->
          </a>
          <a v-if="studnetInfo.Phone==''" @click="addChildphone" style="color:#00aa30;">填写号码</a>
          <a v-if="studnetInfo.Phone!=''" @click="updateChildphone" style="color:#00aa30;">修改号码</a>
        </p>
        <p>
          设备号： {{ studnetInfo.Deviceid }}
          <img
            v-if="isCharging"
            class="icon closeImg"
            src="../../assets/images/chongDian.gif"
            alt=""
          />
          <template v-if="deviceInfo.Online">
            <img
              v-if="deviceInfo.Power > 0 && deviceInfo.Power <= 20"
              class="icon closeImg"
              src="../../assets/images/1.png"
            />
            <img
              v-if="deviceInfo.Power >= 21 && deviceInfo.Power <= 40"
              class="icon closeImg"
              src="../../assets/images/2.png"
            />
            <img
              v-if="deviceInfo.Power >= 41 && deviceInfo.Power <= 60"
              class="icon closeImg"
              src="../../assets/images/3.png"
            />
            <img
              v-if="deviceInfo.Power >= 61 && deviceInfo.Power <= 80"
              class="icon closeImg"
              src="../../assets/images/4.png"
            />
            <img
              v-if="deviceInfo.Power >= 81 && deviceInfo.Power <= 100"
              class="icon closeImg"
              src="../../assets/images/5.png"
            />{{deviceInfo.Power}}%
          </template>
          <!-- <svg
            class="icon closeImg"
            aria-hidden="true"
            style="width: 16px;height: 16px;margin-left: 10px;margin-right: 3px;"
          >
            <use xlink:href="#icon--dianliangbuzu"></use>
          </svg> -->
        </p>
        <p>在线： 
          <span v-if="deviceInfo.Online && studnetInfo.Deviceid !=''" style="color:#00aa30;">设备在线</span> 
          <span v-if="!deviceInfo.Online && studnetInfo.Deviceid !='' " style="color:firebrick;">设备离线</span> 
          <span v-if="studnetInfo.Deviceid ==''" style="color:gray;">设备离线</span> 
        </p>
      </div>
    </div>

    <van-grid class="toolbar" :column-num="3">
      <van-grid-item  icon="c iconfont icon-chongzhi" text="饭卡余额" @click="hrefRecharge" />
      <van-grid-item icon="balance-list-o" text="学生证缴费" @click="hrefPay" />
      <van-grid-item
        icon="c iconfont icon-jilu"
        text="消费记录"
        @click="$router.push({ name: 'order' })"
      />
    </van-grid>

    <van-cell-group class="operate">
      <van-cell
        icon="customiz iconfont icon-tongxunlu2"
        title="通讯录设置"
        @click="$router.push({ name: 'phone' })"
      />

      <van-cell
        icon="customiz iconfont icon-guanyuwomen"
        title="消息留言"
        @click="$router.push({ name: 'sendmsg' })"
      />
      
      <van-cell
        icon="customiz iconfont icon-guanyuwomen"
        title="监护人管理"
        @click="$router.push({ name: 'guardian' })"
      />
      
      <van-cell
        icon="customiz iconfont icon-qingjia"
        title="请假"
        @click="$router.push({ name: 'leave' })"
      />
<!--   
      <van-cell
        icon="customiz iconfont icon-stack"
        title="健康防疫"
        @click="$router.push({ name: 'healthcode' })"
      />
-->   

    </van-cell-group>
    <van-cell-group class="operate">
      
      <van-cell
        icon="customiz iconfont icon-jingyin"
        title="静音时间段查看"
        @click="$router.push({ name: 'mute' })"
      />

      <van-cell
        icon="customiz iconfont icon-stack"
        title="绑定设备"
        @click="jumpDeviceScan"
      />
      

      <van-cell
        icon="customiz iconfont icon-stack"
        title="绑定其他子女"
        @click="$router.push({ name: 'studentinfo' ,query:{bindother:1}})"
      />

      <van-cell icon="customiz iconfont icon-guanji" title="设备远程关机" @click="handleShutdown" />
<!--  
      <van-cell
        icon="customiz iconfont icon-stack"
        title="解绑设备"
        @click="handleUnbind"
      /> 
-->    
    </van-cell-group>

    <van-cell-group class="system">
      <van-cell icon="customiz iconfont icon-icon-test" title="注销" @click="handleDel" />
    </van-cell-group>

    <van-dialog
        v-model="showUpdatePhone"
        title="小孩手机号码"
        show-cancel-button
        @confirm="handleChildPhone"
      > 
      <input
        class="dialog-input"
        v-model="curChildPhone"
        type="text"
        placeholder="号码"
      />
      </van-dialog>
  </div>
</template>

<script>
import { Grid, GridItem, Cell, CellGroup, Dialog, Toast } from 'vant'

export default {
  name: 'my',
  data() {
    return {
      showUpdatePhone:false,
  
      curChildPhone:"",
      timer:null,
      studentPic: require('../../assets/images/student.png'),
      picUrl: '',
      isCharging: false,
      school_id: '',
      studnetInfo: {},
      deviceInfo:{
        Online:false,
        Power:""
      }
    }
  },
  created() {
    
  },
  mounted(){
    this.getStudnetInfo();
    this.getDeviceStatus();
    this.timer = setInterval(()=>{
      this.getDeviceStatus();
    },8000)
  },
  beforeDestroy(){
    this.timer && clearTimeout(this.timer)
  },
  methods: {
    // 添加头像
    handleChangePicUrl(e) {
      this.studentPic = window.URL.createObjectURL(e.target.files[0])
      // this.$http
      //   .json_post1(this.$api.user.addTouXiang, {
      //     student_id: localStorage.getItem('studentId'),
      //     uploadFile: window.URL.createObjectURL(e.target.files[0])
      //   })
      //   .then(data => {
      //     if (data.code == 200) {
      //       Toast('头像设置成功')
      //     }
      //   })

      var file = e.target.files[0] //获取文件
      var uploadFile = null
      //如果浏览器支持FileReader
      var reader = new FileReader() //新建一个FileReader对象
      reader.readAsDataURL(file) //读取文件url
      reader.onloadend = e => {
        console.log(e) //输出e,查看其参数
        console.log(e.target.result) //通过e,输出图片的base64码
        uploadFile = e.target.result
        console.log(uploadFile, '123231')
        this.$http
          .json_post(this.$api.user.addTouXiang, {
            student_id: localStorage.getItem('studentId'),
            uploadFile
          })
          .then(data => {
            if (data.code == 200) {
              Toast('头像设置成功')
            }
          })
      }

      // var config = {
      //   headers: { 'Content-Type': 'multipart/form-data' }
      // } //添加请求头
      // this.$http.post('http://127.0.0.1:8081/upload', param, config).then(response => {
      //   console.log(response.data)
      // })
      // this.studentPic = window.URL.createObjectURL(e.target.files[0])
    },
    hrefStudent() {
      this.$router.push({
        name: 'student'
      })
    },
    // 获取学生信息
    getStudnetInfo() {
      //判断是否要刷新学生信息
      if (this.$route.query.studentid !=undefined && this.$route.query.studentid !="" ){
        this.$http
          .json_post(this.$api.baseinfo.getchildinfo, {
            Studentid:eval(this.$route.query.studentid)
          })
          .then(data => {
            if (data.code == 0) {
              localStorage.setItem('currentChild',JSON.stringify(data.data))
              var sinfo = localStorage.getItem("currentChild");
              this.studnetInfo = JSON.parse(sinfo);
              if (this.studnetInfo.Phone=="" && this.studnetInfo.Deviceid !=""){
                Toast("请填写一下小孩手机号码")
              }
              // if (this.studentInfo.schoolId===50000154){
              //   this.showCharge = false
              // }else {
              //   this.showCharge= true
              // }
            }else{
              Toast(data.msg);
            }
          })
      }else {
        var sinfo = localStorage.getItem("currentChild");
        this.studnetInfo = JSON.parse(sinfo);
        if (this.studnetInfo.Phone=="" && this.studnetInfo.Deviceid !=""){
                Toast("请填写一下小孩手机号码")
        }
      }
      
    },
    //获取设备状态
    getDeviceStatus(){
      if (this.studnetInfo.Deviceid=="") {
        return
      }
      this.$http
          .json_post(this.$api.studentcard.getdevicestatus, {
            Deviceid:this.studnetInfo.Deviceid
          })
          .then(data => {
            if (data.code == 0) {
              if (data.data.length==0){
                return
              }
              this.deviceInfo = data.data[0]
            }
          })
    },
    jumpDeviceScan:function(){
      this.$router.push({ name: 'devicescan',query:{studentid:this.studnetInfo.Studentid,studentname:this.studnetInfo.Studentname} })
    },
    addChildphone(){
      this.curChildPhone=""
      this.showUpdatePhone = true
     
    },
    jumpHesuanQrcode(){
      this.$router.push({name:'hesuanqrcode'})
    },
    updateChildphone(){
      this.curChildPhone=this.studnetInfo.Phone
      this.showUpdatePhone = true
    },
    handleChildPhone(){
      //updatestudentphone
      if (this.curChildPhone != ""){
        var TEL_REGEXP = /^1\d{10}$/
        if (!TEL_REGEXP.test(this.curChildPhone)){
          Toast("请填写正确的11位号码")
          return
        }
      }
      this.$http
          .json_post(this.$api.studentcard.updatestudentphone, {
            Studentid:eval(this.studnetInfo.Studentid),
            Phone:this.curChildPhone
          })
          .then(data => {
            if (data.code == 0) {
              this.studnetInfo.Phone = this.curChildPhone
              localStorage.setItem("currentChild",JSON.stringify(this.studnetInfo));
             
              Toast("提交成功");
            }else {
              Toast(data.msg);
            }
          })
    },
    // 设备关机
    handleShutdown() {
      Dialog.confirm({
        getContainer: '#app',
        message: '确定要关机么?'
      })
        .then(() => {
          this.$http
          .json_post(this.$api.studentcard.poweroff, {
            Deviceid:this.studnetInfo.Deviceid
          })
          .then(data => {
            if (data.code == 0) {
              Toast("命令已提交")
            }else{
              Toast(data.msg);
            }
          })
          })
        .catch((err) => {
          // on cancel
          Toast(err.message);
        })
    },
    //解除设备绑定
    handleUnbind() {
      if(this.studnetInfo.Deviceid === "") {
        Toast("没有绑定设备")
        return
      }
      Dialog.confirm({
        getContainer: '#app',
        message: '确定要解除绑定设备么?'
      }).then(() => {
        this.$http.json_post(this.$api.studentcard.unbinddevice,{
          Studentid:eval(this.studnetInfo.Studentid),
          Deviceid:this.studnetInfo.Deviceid
        }).then(data => {
            if (data.code == 0) {
              //Toast("命令已提交")
              this.studnetInfo.Deviceid =""
              //localStorage.removeItem('currentChild')
              localStorage.setItem('currentChild',JSON.stringify(this.studnetInfo))
              Toast('解绑成功')
              //this.$router.push({ name: 'home' })
            }else{
              Toast(data.msg);
            }
          })
       
       
      })
    },
    // 注销
    handleDel() {
      Dialog.confirm({
        getContainer: '#app',
        message: '确定要注销么?'
      }).then(() => {
        this.$http.json_post(this.$api.baseinfo.canceluser).then(data => {
            if (data.code == 0) {
              //Toast("命令已提交")
              localStorage.removeItem('currentChild')
              Toast('注销成功')
              this.$router.push({ name: 'home' })
            }else{
              Toast(data.msg);
            }
          })
       
       
      })
    },

    hrefRecharge() {
      this.$router.push({
        name: 'recharge',
        query: {
          studentId: localStorage.getItem('studentId')
        }
      })
    },
    hrefPay() {
      this.$router.push({
        name: 'pay',
        query: {
          schoolId: this.school_id,
          studentId: localStorage.getItem('studentId')
        }
      })
    }
  },
  components: {
    'van-grid': Grid,
    'van-grid-item': GridItem,
    'van-cell-group': CellGroup,
    'van-cell': Cell
  }
}
</script>

<style lang="scss" scoped>
.my {
  height: calc(100% - 50px);
  overflow: auto;
  .closeImg {
    width: 18px;
    margin-left: 6px;
  }
  .system {
    margin-bottom: 15px;
  }
  ::v-deep {
    .van-icon-customiz {
      padding-right: 10px;
    }
    .icon-qingjia {
      color: #df0000;
      font-size: 17px;
    }
    .icon-tongxunlu2 {
      color: #0076ff;
    }
    .icon-jingyin,
    .icon-guanji,
    .icon-stack {
      color: $primary-color;
    }
    .icon-guanji,
    .icon-stack,
    .icon-guanyuwomen,
    .icon-jingyin {
      font-weight: bold;
    }
    .icon-guanji {
      color: #ffc347;
    }
    .icon-guanyuwomen {
      color: $primary-color;
    }
    .icon-icon-test {
      color: #ffc347;
    }
  }
}

.user {
  display: flex;
  margin-bottom: 15px;
  padding: 16px;
  background-color: #fff;
  .user-left {
    width: 80px;
    text-align: center;
    .user-left__img {
      font-size: 50px;
      width: 50px;
      max-height: 50px;
      object-fit: cover;
      border-radius: 50%;
    }
    .user-left__name {
      margin-top: 5px;
      margin-bottom: 5px;
      font-weight: 500;
    }
    .user-left__switch {
      font-size: 16px;
      font-weight: 400;
    }
  }

  .user-right {
    margin-left: 10px;
    color: $text-secondary-color;
    font-size: 12px;
    p {
      display: flex;
      align-items: center;
      color: #999;
      margin-bottom: 10px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
    .call {
      a {
        color: #999;
      }
    }
  }
}

.toolbar {
  ::v-deep .van-grid-item__icon {
    color: #ffcf44;
  }
  margin-bottom: 15px;
  .van-icon ::v-deep {
    color: #ffcf44;
  }
}
.dialog-input {
    display: block;
    width: 275px;
  
    height: 0.8rem;
    line-height: 17px;
    font-size: 15px;
    font-weight: 500;
    color: #999;
    text-indent: 5px;
    border: 1px solid #ddd;
    background: none;
    outline: none;
    margin: 0.6rem auto;
  }
.operate {
  margin-bottom: 15px;
}
</style>
